<template>
  <div class="invoice-by-date-report">
    <v-card flat class="report-page-card">
      <ReportViewBar
        :title="title"
        :start="start"
        :end="end"
        :export-data="exportData"
        :export-fields="exportFields"
      />

      <v-card-text class="report-content">
        <InvoiceReport :start="start" :end="end" @export-data="setExportData" />
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import ReportViewBar from "@/components/ReportViewBar";

const InvoiceReport = () =>
  import("@/modules/ReportView/GlobalReport/Invoice.vue");

export default {
  name: "invoice-by-date-report",

  components: {
    ReportViewBar,
    InvoiceReport,
  },

  props: {
    title: {
      type: String,
      default: "Invoice By Date",
    },
  },

  data() {
    return {
      start: null,
      end: null,
      exportData: [],
      exportFields: {
        "Invoice #": "localId",
        Date: "date",
        Customer: "customerName",
        Amount: "total",
        Payment: "payment",
        Due: "due",
      },
    };
  },

  created() {
    this.start = this.$route.query.start || null;
    this.end = this.$route.query.end || null;
  },

  methods: {
    setExportData(rows) {
      this.exportData = rows || [];
    },
  },
};
</script>

<style scoped>
.report-page-card {
  border-radius: 18px;
  overflow: hidden;
}
.invoice-by-date-report {
  background: #f5f7fb;
  min-height: 100vh;
  padding: 16px;
}
.report-content {
  padding: 20px;
}
</style>